import { getPersistData } from "./storePersist";

export const addToken = (mobiUrl: string, token?: string) => {
  if (!mobiUrl) {
    return "";
  }

  let url = mobiUrl;
  let currentToken = token;
  const tokenPara = "token";
  const tokenStartIndex = mobiUrl.indexOf(tokenPara);
  if (tokenStartIndex > -1) {
    const tokenEndindex = mobiUrl.slice(tokenStartIndex).indexOf("&");
    if (tokenEndindex > -1) {
      url =
        mobiUrl.slice(0, tokenStartIndex) +
        mobiUrl.slice(tokenStartIndex + tokenEndindex + 1);
    } else {
      url = mobiUrl.slice(0, tokenStartIndex - 1);
    }
  }

  if (!token) {
    const userData = getPersistData();
    if (userData && userData.token) {
      currentToken = userData.token;
    }
  }

  if (!currentToken) {
    return url;
  }

  if (mobiUrl.indexOf("?") > -1) {
    url += `&${tokenPara}=${currentToken.slice(currentToken.indexOf(" ") + 1)}`;
  } else {
    url += `?${tokenPara}=${currentToken.slice(currentToken.indexOf(" ") + 1)}`;
  }
  return url;
};
